/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense, lazy } from 'react';

import SuspenseLoader from 'components/SuspenseLoader';

const Loader = (Component: any) => {
  return (props: any) => {
    return (
      <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
      </Suspense>
    );
  };
};

const Home = Loader(
  lazy(() => {
    return import('pages/Home');
  }),
);

const Maintenance = Loader(
  lazy(() => {
    return import('pages/Maintenance');
  }),
);

const Recovery = Loader(
  lazy(() => {
    return import('pages/Recovery');
  }),
);

export const Signin = Loader(
  lazy(() => {
    return import('pages/Signin');
  }),
);

const Layout = Loader(
  lazy(() => {
    return import('components/Layout');
  }),
);

const ListCobapAssociation = Loader(
  lazy(() => {
    return import('pages/Entities/Association/ListView');
  }),
);

const FormAssociationCobap = Loader(
  lazy(() => {
    return import('pages/Entities/Association/FormView');
  }),
);
const NewAssociationCobap = Loader(
  lazy(() => {
    return import('pages/Entities/Association/NewAssociation');
  }),
);

const ListCobapFederation = Loader(
  lazy(() => {
    return import('pages/Entities/Federation/ListView');
  }),
);

const FormFederationCobap = Loader(
  lazy(() => {
    return import('pages/Entities/Federation/FormView');
  }),
);
const NewFederationCobap = Loader(
  lazy(() => {
    return import('pages/Entities/Federation/NewFederation');
  }),
);

const ListProposalStatus = Loader(
  lazy(() => {
    return import('pages/Proposal/ListView');
  }),
);
const CustomerList = Loader(
  lazy(() => {
    return import('pages/Customer/ListView');
  }),
);

const FormCustomerStatus = Loader(
  lazy(() => {
    return import('pages/Customer/FormView');
  }),
);

const ListUsers = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Users/ListView');
  }),
);
const NewUser = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Users/NewUser');
  }),
);

const FormUser = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Users/FormView');
  }),
);
const ListPartners = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Partner/ListView');
  }),
);
const FormPartners = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Partner/FormView');
  }),
);

const NewPartners = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Partner/NewPartner');
  }),
);

const ListViewCompany = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Company/ListViewCompany');
  }),
);

const FormCompanies = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Company/FormViewCompany');
  }),
);

const NewCompany = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Company/NewCompany');
  }),
);

const GroupSettings = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Groups/ListView');
  }),
);

const FormGroup = Loader(
  lazy(() => {
    return import('pages/UserManagementSettings/Groups/FormView');
  }),
);

const FormProposalStatus = Loader(
  lazy(() => {
    return import('pages/Proposal/FormView');
  }),
);

const ReportsCobap = Loader(
  lazy(() => {
    return import('pages/Entities/Reports');
  }),
);

const RelationshipServices = Loader(
  lazy(() => {
    return import('pages/Entities/RelationshipServices');
  }),
);

const Dashboard = Loader(
  lazy(() => {
    return import('pages/Dashboard');
  }),
);

const PendingSubscriptions = Loader(
  lazy(() => {
    return import('pages/Entities/PendingSubscriptions');
  }),
);

const SendNotification = Loader(
  lazy(() => {
    return import('pages/Notification/SendNotification');
  }),
);

const ProductList = Loader(
  lazy(() => {
    return import('pages/Product/ListView');
  }),
);

const ProductForm = Loader(
  lazy(() => {
    return import('pages/Product/FormView');
  }),
);

const ProductGroupingList = Loader(
  lazy(() => {
    return import('pages/ProductGrouping/ListView');
  }),
);

const ProductGroupingForm = Loader(
  lazy(() => {
    return import('pages/ProductGrouping/FormView');
  }),
);

const BenefitList = Loader(
  lazy(() => {
    return import('pages/Benefit/ListView');
  }),
);

const BenefitForm = Loader(
  lazy(() => {
    return import('pages/Benefit/FormView');
  }),
);

const CoverageList = Loader(
  lazy(() => {
    return import('pages/Coverage/ListView');
  }),
);

const CoverageForm = Loader(
  lazy(() => {
    return import('pages/Coverage/FormView');
  }),
);

const BillingGrupoList = Loader(
  lazy(() => {
    return import('pages/BillingGrupo/ListView');
  }),
);

const BillingGrupoForm = Loader(
  lazy(() => {
    return import('pages/BillingGrupo/FormView');
  }),
);

interface IRoutes {
  path: string;
  title: string;
  component: React.ReactNode;
  isPrivate: boolean;
}

const routes: IRoutes[] = [
  {
    path: '/',
    title: 'Home',
    component: <Home />,
    isPrivate: true,
  },
  {
    path: '/maintenance',
    title: 'Maintenance',
    component: <Maintenance />,
    isPrivate: false,
  },
  {
    path: '/signin',
    title: 'Signin',
    component: <Signin />,
    isPrivate: false,
  },
  {
    path: '/recoverypassword/:base64',
    title: 'Recovery',
    component: <Recovery />,
    isPrivate: false,
  },
  {
    path: '/*',
    title: 'Layout',
    component: <Layout />,
    isPrivate: false,
  },
  {
    path: '/entities/list/association',
    title: 'List Cobap Association',
    component: <ListCobapAssociation />,
    isPrivate: true,
  },
  {
    path: '/entities/edit/association/:id',
    title: 'List Cobap Association',
    component: <FormAssociationCobap />,
    isPrivate: true,
  },
  {
    path: '/entities/new/association',
    title: 'New Cobap Association',
    component: <NewAssociationCobap />,
    isPrivate: true,
  },
  {
    path: '/entities/list/federation',
    title: 'List Cobap Federation',
    component: <ListCobapFederation />,
    isPrivate: true,
  },
  {
    path: '/entities/edit/federation/:id',
    title: 'List Cobap Federation',
    component: <FormFederationCobap />,
    isPrivate: true,
  },
  {
    path: '/entities/new/federation',
    title: 'New Cobap Federation',
    component: <NewFederationCobap />,
    isPrivate: true,
  },
  {
    path: '/entities/PendingSubscriptions',
    title: 'Assinaturas pendentes',
    component: <PendingSubscriptions />,
    isPrivate: true,
  },
  {
    path: '/proposal/list',
    title: 'Reports',
    component: <ListProposalStatus />,
    isPrivate: true,
  },
  {
    path: '/customer/list',
    title: 'Clients',
    component: <CustomerList />,
    isPrivate: true,
  },
  {
    path: '/customer/:id',
    title: 'Cliente',
    component: <FormCustomerStatus />,
    isPrivate: true,
  },
  {
    path: '/proposal/:id',
    title: 'Reports',
    component: <FormProposalStatus />,
    isPrivate: true,
  },
  {
    path: '/entities/reports',
    title: 'Relatório Cobap',
    component: <ReportsCobap />,
    isPrivate: true,
  },
  {
    path: '/entities/relationship-services',
    title: 'Relacionamento Serviços',
    component: <RelationshipServices />,
    isPrivate: true,
  },
  {
    path: '/dashboard',
    title: 'dashboard',
    component: <Dashboard />,
    isPrivate: true,
  },
  {
    path: '/userSettings/users',
    title: 'Users',
    component: <ListUsers />,
    isPrivate: true,
  },
  {
    path: '/userSettings/users/newUsers',
    title: 'Users',
    component: <NewUser />,
    isPrivate: true,
  },
  {
    path: '/userSettings/group',
    title: 'Users',
    component: <GroupSettings />,
    isPrivate: true,
  },
  {
    path: '/userSettings/group/:id',
    title: 'Users',
    component: <FormGroup />,
    isPrivate: true,
  },
  {
    path: '/userSettings/partner',
    title: 'Partner',
    component: <ListPartners />,
    isPrivate: true,
  },
  {
    path: '/userSettings/partner/:id',
    title: 'Partner',
    component: <FormPartners />,
    isPrivate: true,
  },
  {
    path: '/userSettings/partner/newPartner',
    title: 'Nova Partner',
    component: <NewPartners />,
    isPrivate: true,
  },
  {
    path: '/userSettings/company/:id',
    title: 'Company',
    component: <FormCompanies />,
    isPrivate: true,
  },
  {
    path: '/userSettings/company',
    title: 'Empresa',
    component: <ListViewCompany />,
    isPrivate: true,
  },
  {
    path: '/userSettings/company/newCompany',
    title: 'Nova Empresa',
    component: <NewCompany />,
    isPrivate: true,
  },
  {
    path: '/userSettings/users/:id',
    title: 'Users',
    component: <FormUser />,
    isPrivate: true,
  },
  {
    path: '/notifications/send',
    title: 'Enviar notificação',
    component: <SendNotification />,
    isPrivate: true,
  },
  {
    path: '/product/list',
    title: 'Produtos',
    component: <ProductList />,
    isPrivate: true,
  },
  {
    path: '/product/:id',
    title: 'Produto',
    component: <ProductForm />,
    isPrivate: true,
  },
  {
    path: '/product/new',
    title: 'Novo Produto',
    component: <ProductForm />,
    isPrivate: true,
  },
  {
    path: '/product-grouping/list',
    title: 'Agrupamentos de Produtos',
    component: <ProductGroupingList />,
    isPrivate: true,
  },
  {
    path: '/product-grouping/:id',
    title: 'Agrupamento de Produtos',
    component: <ProductGroupingForm />,
    isPrivate: true,
  },
  {
    path: '/product-grouping/new',
    title: 'Novo Agrupamento de Produtos',
    component: <ProductGroupingForm />,
    isPrivate: true,
  },
  {
    path: '/benefit/list',
    title: 'Benefícios',
    component: <BenefitList />,
    isPrivate: true,
  },
  {
    path: '/benefit/:id',
    title: 'Benefício',
    component: <BenefitForm />,
    isPrivate: true,
  },
  {
    path: '/benefit/new',
    title: 'Novo Benefício',
    component: <BenefitForm />,
    isPrivate: true,
  },
  {
    path: '/coverage/list',
    title: 'Coberturas',
    component: <CoverageList />,
    isPrivate: true,
  },
  {
    path: '/coverage/:id',
    title: 'Cobertura',
    component: <CoverageForm />,
    isPrivate: true,
  },
  {
    path: '/coverage/new',
    title: 'Nova Cobertura',
    component: <CoverageForm />,
    isPrivate: true,
  },
  {
    path: '/billing-grupo/list',
    title: 'Grupos de Cobrança',
    component: <BillingGrupoList />,
    isPrivate: true,
  },
  {
    path: '/billing-grupo/:id',
    title: 'Grupo de Cobrança',
    component: <BillingGrupoForm />,
    isPrivate: true,
  },
  {
    path: '/billing-grupo/new',
    title: 'Novo Grupo de Cobrança',
    component: <BillingGrupoForm />,
    isPrivate: true,
  },
];

export default routes;
